import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledHeading = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;

export const AlgorithmIcon = styled.img`
  flex-shrink: 0;
  width: 50px;
  height: 45px;
  margin-right: 0.75rem;
`;

export const AlgorithmTitleText = styled.span`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  white-space: break-spaces;
  text-align: left;

  color: ${({ theme }) => theme.colors.secondary.base};
`;

export const AlgorithmPDFText = styled.span`
  text-align: left;
  color: ${({ theme }) => theme.colors.primary};
  padding-left: ${({ theme }) => theme.space.xs};
`;
